"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Loading_1 = __importDefault(require("@modules/Loading"));
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const PageButtonGroup_1 = __importDefault(require("./components/PageButtonGroup"));
const SearchForm_1 = __importDefault(require("./components/SearchForm"));
const AddForm_1 = __importDefault(require("./components/AddForm"));
const SearchResultTable_1 = __importDefault(require("./components/SearchResultTable"));
const pageService_1 = require("./service/pageService");
function index() {
    const { loadingState } = (0, react_redux_1.useSelector)((state) => (Object.assign({}, state.df0001)));
    const [pageRoutes, setPageRoutes] = react_1.default.useState(pageService_1.initPageRoutes);
    const [searchResultTableTitles, setSearchResultTableTitles] = react_1.default.useState(pageService_1.initSearchResultTableTitle);
    const resetPage = () => {
        setPageRoutes(Object.assign(Object.assign({}, pageService_1.initPageRoutes), { searchForm: Object.assign(Object.assign({}, pageService_1.initPageRoutes.searchForm), { isDisplay: true }) }));
    };
    react_1.default.useEffect(() => {
        resetPage();
        return () => {
            resetPage();
            setSearchResultTableTitles(pageService_1.initSearchResultTableTitle);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "demoForm__wrapper" }, { children: [loadingState ? (0, jsx_runtime_1.jsx)(Loading_1.default, {}) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), (0, jsx_runtime_1.jsx)(PageButtonGroup_1.default, { pageRoutes: pageRoutes, setPageRoutes: setPageRoutes }), pageRoutes.searchForm.isDisplay && (0, jsx_runtime_1.jsx)(SearchForm_1.default, { setPageRoutes: setPageRoutes, pageRoutes: pageRoutes }), pageRoutes.addForm.isDisplay && (0, jsx_runtime_1.jsx)(AddForm_1.default, { setPageRoutes: setPageRoutes, pageRoutes: pageRoutes }), pageRoutes.searchResult.isDisplay && ((0, jsx_runtime_1.jsx)(SearchResultTable_1.default, { searchResultTableTitles: searchResultTableTitles }))] })));
}
exports.default = index;
